if (!App.H.hasClass('page-catalog')) {
    let $btnApplyFilter = $(".js-btn-apply");

    $btnApplyFilter.click(function () {
        getNewsByParams();
    });

    $(".js-filter-open").click(function () {
        $(".js-news-wrapper").addClass("_filter-opened");
    });

    $(".js-filter-close").click(function () {
        $(".js-news-wrapper").removeClass("_filter-opened");
    });

    if ($('.js-sorting').length) {
        App.H.on('change', '.js-sorting-radio input', function (e) {
            getNewsByParams();
            e.preventDefault();
        });
    }

    if ($(".page-news").length || $(".page-vacancies").length) {
        App.H.on('change', '.js-checkbox input', function () {
            const $currentFilter = $(this).closest('.js-filter');

            if (!$(this).closest('.js-checkbox-all').length) {
                $currentFilter.find('.js-checkbox-all input').prop("checked", false);
            } else {
                $currentFilter.find('.js-checkbox input').prop("checked", false);
                $(this).prop("checked", true);
            }
        });

        App.H.on('click', '.js-btn-reset', function () {
            const $currentFilter = $(this).closest('.js-filter');
            $currentFilter.find('.js-checkbox input').prop("checked", false);
            $currentFilter.find('.js-checkbox-all input').prop("checked", true);

            getNewsByParams();
        });
    }
}

function getNewsByParams() {
    $(".js-dropdown._opened").removeClass("_opened");
    $(".js-dropdown-content").slideUp(150);

    if (App.W.width() < 768) {
        $(".js-news-wrapper").removeClass("_filter-opened");
        App.B.removeClass("_noscroll");
    }

    const $newsForm = $('.js-form-news');
    $newsForm.addClass('_loading');

    $.ajax({
        url: $newsForm.attr('action'),
        method: $newsForm.attr('method') || "get",
        data: $newsForm.serialize(),
        success: function (data) {
            if (data.success) {
                setTimeout(() => {
                    $newsForm.removeClass('_loading');

                    if ($(".js-news-list").length) {
                        $(".js-news-list").empty().append(data.content);
                    }
                    if ($(".js-vacancies-list").length) {
                        $(".js-vacancies-list").empty().append(data.content);
                    }

                    if (data.pagination && data.pagination.length > 0) {
                        $('.js-pagination').html('').append(data.pagination);
                    } else {
                        $('.js-pagination').html('');
                    }

                    if (data.redirect_url) {
                        history.pushState(null, null, data.redirect_url);
                    }

                    // Подсчитываем количество активных фильтров
                    let $filters = $(".js-news-filters-content .js-filter");
                    let colFiltersChecked = 0;
                    $filters.each(function (idx, itm) {
                        let lengthChecked = $(itm).find(".js-checkbox:not(.js-checkbox-all)").find("input:checked").length;
                        if (lengthChecked > 0) {
                            colFiltersChecked++;
                        } else {
                            colFiltersChecked = 0;
                        }
                    });
                    if (colFiltersChecked > 0) {
                        $(".js-quantity-active").text(colFiltersChecked).addClass("_active");
                    } else {
                        $(".js-quantity-active").text('').removeClass("_active");
                    }
                }, 1000);
            }
        },
    });
}
